import React from 'react';
import classNames from 'classnames';
import Pagination from '../pagination';
import styles from './pagination-comments.scss';

const PaginationComments = props =>
  <div className={styles.container}>
    <Pagination
      className={styles.pagination}
      arrowClass={styles.arrow}
      innerClass={styles.page}
      activeClass={classNames(styles.active, 'button-color')}
      {...props}
    />
  </div>;

export default PaginationComments;



// WEBPACK FOOTER //
// ./app/components/pagination-comments/pagination-comments.js